import { render, staticRenderFns } from "./reward-list.vue?vue&type=template&id=e55135f0&scoped=true&"
import script from "./reward-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./reward-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./reward-list.vue?vue&type=style&index=0&id=e55135f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55135f0",
  null
  
)

export default component.exports